import { formatDate } from '@/@core/utils/utils'

export const getTemplate10 = (
  report: any,
  samples: any[],
  affected_child_clinicalInformation: any,
  t: any
) => {
  return [
    {
      type: 'block-title-yunnan',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },

    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '基本信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `姓名` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `样本编号` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `性别` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `年龄（岁）` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `受检者` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `样本类型` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `采样日期` }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.patient?.patientName ?? '-' }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.sample?.name ?? '-' }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.patient?.gender ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${
                          row.patient?.dateOfBirth
                            ? (Math.floor(
                                (new Date().valueOf() -
                                  new Date(
                                    row.patient?.dateOfBirth
                                  ).valueOf()) /
                                  3.15576e10
                              ) <= 0
                                ? 0
                                : Math.floor(
                                    (new Date().valueOf() -
                                      new Date(
                                        row.patient?.dateOfBirth
                                      ).valueOf()) /
                                      3.15576e10
                                  )) + '岁'
                            : '-'
                        }`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.patient?.patientName ?? '-' }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.sample?.type ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      { text: formatDate(row.sample?.createdAt) ?? '-' }
                    ]
                  }
                ]
              }
            ]
          }
        }),
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `联系电话` }]
                }
              ]
            },
            {
              type: 'table-cell-c6',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `-` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `先证者临床表现及家族史` }]
                }
              ]
            },
            {
              type: 'table-cell-c6',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: affected_child_clinicalInformation ?? '-'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测项目` }]
                }
              ]
            },
            {
              type: 'table-cell-c6',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `-` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `送检医师` }]
                }
              ]
            },
            {
              type: 'table-cell-c6',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `-` }]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测结论'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `未发现明确与所关注临床表型一致的致病性基因变异。`
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },

    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测方法与分析'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `(1)高通量基因测序：基于受检者基因组DNA，构建基因组文库，捕获相关目的基因片段并进行富集；富集的目的基因片段利用MGISEQ-2000测序平台进行测序，目标区域平均测序深度≥200×，其中目标区平均深度>20×的位点所占比例>98.5%。`
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(2)数据分析：测序数据运用BWA与UCSC hg19人类参考基因组序列进行比对，并对目标区域的覆盖度和测序质量进行评估；依据严格的筛选标准对变异进行过滤，并添加HGMD数据库和蛋白功能预测软件等的相关注释信息。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(3)数据解读：从数十万个变异中筛选与疾病明确相关或可能与疾病相关的变异。变异分级基于美国医学遗传学和基因组学学会（ACMG）相关指南。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(4)二代测序检测所发现与疾病相关的变异位点经一代测序技术验证，结果见附录。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '局限性说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(1)由于胎儿可观察表型特征有限，并且无遗传代谢特征和行为、智能发育评估等资料，检测结果不能排除出生后发生严重疾病的风险。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(2)鉴于当前医学检测技术水平的限制和受检者个体差异等原因，即使在检测人员已经履行了工作职责和操作规程的前提下，仍无法保证100%的准确性以及100%的成功率。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(3)鉴于当前医学检测技术水平的限制和受检者个体差异等原因，本检测不能保证覆盖100%的外显子区域，对20bp以上的插入/缺失（Indels）存在局限性，不适于检测特殊类型变异（包括但不限于串联重复序列、高度同源序列、内含子变异、基因调控区、高GC含量区域、假基因区域变异、动态突变、基因甲基化、复杂重组、基因重排、低比例嵌合、体细胞变异、poly结构等）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(4)本检测无法检测高度复杂区域，涉及的相关疾病包括但不限于血友病和地中海贫血等需采用长片段PCR（LD-PCR）、跨越断裂点PCR（Gap-PCR）等方法检测的疾病。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(5)本检测技术无法保证外显子水平的缺失重复变异（exon CNV 变异）、染色体拷贝数变异（Large CNV 变异等）、单亲二体（UPD）、杂合性缺失（LOH）等的检出。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(6)本检测无法保证线粒体变异的检出，不能检测线粒体基因组拷贝数变化。对于线粒体变异，仅酌情提示内部数据库收录的，且突变率≥20%的位点。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(7)本检测只针对已知的与疾病相关或可能相关的基因，即所有数据解读基于目前对疾病与致病基因的认识，目前尚未明确的基因无法解读。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(8)本检测无法排除在受检者的基因组中存在本项目检测范围之外的其它致病性改变。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '临床建议'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(1)遗传咨询。本结果仅供临床医生参考，不作为最终诊断，最终的临床诊断必须由临床医生结合受检者的临床情况完成最终评估，相关解释请咨询临床医生。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '(2)临床需要时加做其它检查。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: `注：本报告仅对本次检测标本负责，本科室对以上检测结果保留最终解释权，如有疑义请在收到报告后7个工作日内与我们联系。`
            }
          ]
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: 'ACMG指南证据项说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1：当一个疾病的致病机制为功能丧失（LOF）时，检出变异为无功能变异（无义突变、移码突变、经典±1或2的剪接突变、起始密码子变异、单个或多个外显子缺失）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Strong：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Moderate：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Supporting：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS1：与先前已确定为致病性的变异有相同的氨基酸改变。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2：患者的新发变异, 且无家族史（经双亲验证）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Very Strong：PS2 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Moderate：PS2 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Supporting：PS2 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS3：体内、体外功能实验已明确会导致基因功能受损的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4：变异出现在患病群体中的频率显著高于对照群体。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4_Moderate：PS4 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4_Supporting：PS4 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM1：位于热点突变区域，和/或位于已知无良性变异的关键功能域。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM2：ESP 数据库、千人数据库、EXAC 数据库中正常对照人群中未发现的变异（或隐性遗传病中极低频位点）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3：在隐性遗传病中，在反式位置上检测到致病变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Very Strong：PM3 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Strong：PM3 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Supporting：PM3 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM4：非重复区框内插入/缺失或终止密码子丧失导致的蛋白质长度变化。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM5：新的错义突变导致氨基酸变化，此变异之前未曾报道，但是在同一位点，导致另外一种氨基酸的变异已经确认是致病性的。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6：未经父母样本验证的新发变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Very Strong：PM6 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Strong：PM6 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Supporting：PM6 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1：突变与疾病在家系中共分离（在家系多个患者中检测到此变异）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1_Strong：PP1 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1_Moderate：PP1 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP2：对某个基因来说，如果这个基因的错义变异是造成某种疾病的原因，并且这个基因中良性变异所占的比例很小，在这样的基因中所发现的新的错义变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP3：多种统计方法预测出该变异会对基因或基因产物造成有害的影响，包括保守性预测、进化预测、剪接位点影响等。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP4：变异携带者的表型或家族史高度符合某种单基因遗传疾病。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BA1：ESP 数据库、千人数据库、EXAC 数据库中等位基因频率>5%的变异（若无特异基因或变异的频率阈值矫正）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS1：等位基因频率大于疾病发病率。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS2：对于早期完全外显的疾病，在健康成年人中发现该变异（隐性遗传病发现纯合、显性遗传病发现杂合, 或者X 连锁半合子）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS3：在体内外实验中确认对蛋白质功能和剪接没有影响的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS4：在一个家系成员中缺乏共分离。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP1：已知一个疾病的致病原因是由于某基因的截短变异，在此基因中所发现的错义变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP2：在显性遗传病中又发现了另一条染色体上同一基因的一个已知致病变异，或者是任意遗传模式遗传病中又发现了同一条染色体上同一基因的一个已知致病变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP3：功能未知重复区域内的缺失/插入，同时没有导致基因编码框改变。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP4：多种统计方法预测出该变异会对基因或基因产物无影响，包括保守性预测、进化预测、剪接位点影响等。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP5：在已经有另一分子致病原因的病例中发现的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP7：同义变异且预测不影响剪接。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '致病性计算方法'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r8',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '致病的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Pathogenic)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥1个强(PS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥2个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+1个中等(PM)+1个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(PS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+≥3个中等(PM1)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+1个中等(PM)+≥4个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r6',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '可能致病的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Likely pathogenic)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+1个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+1-2个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥3个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '良性的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Benign)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(BS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(BS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '可能良性的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Likely benign)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(BS)+1个支持(BP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个支持(BP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '意义不明确的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(VUS)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `不满足上述标准或`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `良性和致病标准相互矛盾`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: '注：各致病性等级对应序号间为“或”的关系'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'yunnan-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
